import { Color } from "./base-data";

const colors: Color[][] = [
  ["O", "G", "B", "B", "R", "R", "R", "G", "G", "G", "Y", "Y", "Y", "R", "R"],
  ["G", "G", "G", "G", "R", "Y", "G", "R", "G", "G", "R", "Y", "Y", "R", "Y"],
  ["B", "B", "O", "G", "Y", "Y", "G", "B", "R", "R", "R", "R", "O", "O", "Y"],
  ["B", "O", "O", "O", "O", "G", "G", "B", "B", "B", "B", "O", "R", "O", "O"],
  ["B", "R", "O", "R", "B", "O", "O", "O", "B", "Y", "O", "O", "R", "Y", "O"],
  ["R", "R", "R", "R", "B", "B", "B", "Y", "Y", "Y", "O", "B", "G", "G", "G"],
  ["Y", "Y", "Y", "Y", "G", "B", "Y", "Y", "O", "O", "G", "G", "B", "B", "B"],
];

const stars: boolean[][] = [
  [
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
  ],
  [
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
];

export const board = {
  colors,
  stars,
};
